import styled from 'styled-components';
import { getValidHexOrRgbaColor } from '@ardoq/color-helpers';

const SvgShape = styled.svg`
  cursor: default;
  height: 50px;
  width: 100px;
  fill: ${props => props.color};
  color: ${props => props.color};
`;

interface SvgShapePreviewProps {
  color: string;
  shapeId: string;
}
export const SvgShapePreview = ({ color, shapeId }: SvgShapePreviewProps) => {
  return (
    <SvgShape viewBox="0 0 100 50" color={getValidHexOrRgbaColor(color)}>
      <use href={`#${shapeId}`} />
    </SvgShape>
  );
};
